import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { Application } from 'stimulus';
import SearchController from '../controllers/search_controller';
import ThemeController from '../controllers/theme_controller';
import SwiperController from '../controllers/swiper_controller';
import CheckoutController from '../controllers/checkout_controller';
import ModalController from '../controllers/modal_controller';
import { postMessage } from 'vendor/helpers';

const application = Application.start();
application.register("search", SearchController);
application.register('theme', ThemeController);
application.register('swiper', SwiperController);
application.register('checkout', CheckoutController);
application.register('modal', ModalController);

document.addEventListener('readystatechange', e => {
  if (document.readyState === 'complete') {
    postMessage('webViewLoaded');
  }
});
